import { updateField } from 'vuex-map-fields'

export default {
  TOGGLE_SIDEBAR (state, payload) {
    state.sidebar = payload
  },
  updateField
}
